import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { canAccessAdmin } from '../utils/roles';
import { hasVerifiedEmail } from '../utils/platformAccess';

const AdminRoute: React.FC = () => {
  const { isAuthenticated, isProfileComplete, user, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600"></div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (!hasVerifiedEmail(user)) {
    return <Navigate to="/verify-email" replace />;
  }

  if (!isProfileComplete) {
    return <Navigate to="/profile-setup" replace />;
  }

  if (user?.needsLegalAcceptance) {
    return <Navigate to="/accept-legal" replace />;
  }

  if (!canAccessAdmin(user)) {
    return <Navigate to="/dashboard" replace />;
  }

  return <Outlet />;
};

export default AdminRoute; 